import { useQuery } from '@tanstack/react-query';
import { fetchPendingTasks, TasksResponse } from '../adapters/pendingTasksAdapter';

export const usePendingTasks = () => {
  return useQuery<TasksResponse, Error>({
    queryKey: ['dashboard', 'pending-tasks'],
    queryFn: fetchPendingTasks,
    refetchOnWindowFocus: false,
  });
};
